const hostApi = window.location.hostname !== 'face.ehailuo.com'
  ? 'http://api.ehailuo.com'
  : 'https://api.ehailuo.com';
const hostService = window.location.hostname !== 'face.ehailuo.com'
  ? 'http://service.ehailuo.com'
  : 'https://service.ehailuo.com';

export default {
  hostApi,
  hostService,
};
